import { module } from "angular";
import { SubmitButtonComponent } from "./SubmitButtonComponent";

module("mmGui").component("irSubmitButton", new SubmitButtonComponent());
